import React from 'react';
import { ShopifyIcon } from 'tuui';
import { defaultMessages } from '../../taboola-common-frontend-modules/i18n/config/messages';
import { Woocommerce } from '../icons/Woocommerce';
import { Wordpress } from '../icons/Wordpress';

export const THIRD_PARTY_PLATFORM = {
    WORDPRESS: 'wp',
    SHOPIFY: 'shopify',
    WOOCOMMERCE: 'wc',
};

const wordPressColor = '#21759b';
const shopifyColor = '#95BF46';
const woocommerceColor = '#7F54B3';

const PLATFORM_CONFIG = {
    [THIRD_PARTY_PLATFORM.WORDPRESS]: {
        name: 'WordPress',
        icon: () => <Wordpress width={40} height={40} style={{ color: wordPressColor }} />,
    },
    [THIRD_PARTY_PLATFORM.SHOPIFY]: {
        name: 'Shopify',
        icon: () => <ShopifyIcon width={40} height={40} style={{ color: shopifyColor }} />,
    },
    [THIRD_PARTY_PLATFORM.WOOCOMMERCE]: {
        name: 'Woocommerce',
        icon: () => <Woocommerce width={50} height={50} style={{ color: woocommerceColor }} />,
    },
};

export const getPlatformName = platformCode => {
    return PLATFORM_CONFIG[platformCode]?.name || defaultMessages['3p-connect.default.platform'] || 'Your';
};

export const getPlatformIcon = platformCode => {
    return PLATFORM_CONFIG[platformCode]?.icon || Wordpress;
};
